export default "__VITE_ASSET__BMEhxruf__"